import { useState, useEffect } from "react";
import { selects } from "../../lib/select/initSelectize";
import { Link } from "react-router-dom";
import { payment } from "../../lib/api/api";
import { HandySvg } from "handy-svg";
import iconRightArrow from "../../assets/icons/svg-sprite/arrow-right.svg";
import iconQuestion from "../../assets/icons/svg-sprite/question.svg";

const FillUpAccount = ({ cardID, setMessage }) => {
  const [options, setOptions] = useState([]);
  const [amountError, setAmountError] = useState(false);
  const [methodError, setMethodError] = useState(false);
  const [action, setAction] = useState("");
  const [method, setMethod] = useState("");
  const [serial, setSerial] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [orderID, setOrderID] = useState("");

  useEffect(() => {
    if (options.length > 0) {
      selects.fillupAccount(options);
    }
  }, [options]);

  useEffect(() => {
    const parameters = window.location.search.substr(1);
    if (parameters) {
      const obj = parameters.split("&").reduce((res, a) => {
        var t = a.split("=");
        res[decodeURIComponent(t[0])] =
          t.length == 1 ? null : decodeURIComponent(t[1]);
        return res;
      }, {});
      if (obj.payment) {
        const banner = document.getElementById("messageBanner");
        banner.style.removeProperty("display");
        if (obj.payment === "success") {
          setMessage(
            "Средства будут зачислены в ближайшее время после подтверждения платежа в платежной системе",
          );
        } else {
          setMessage("Произошла ошибка оплаты, попробуйте позже");
        }
        const url = new URL(window.location.href);
        url.searchParams.delete("payment");
        window.history.replaceState({}, document.title, url.toString());
      }
    }
  }, []);

  useEffect(() => {
    if (cardID !== null) {
      submitForm();
      payment
        .payments(cardID)
        .then((res) => {
          const paysystems = [];
          res.paysystems.forEach((item) => {
            if (item.status === "stable") {
              paysystems.push({
                name: item.name,
                value: item.code,
                icon: item.media.thumb.url,
              });
            }
          });
          setOptions(paysystems);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [cardID]);

  function submitForm() {
    const formElement = document.getElementById("paymentForm");
    formElement.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(formElement);
      formData.get("fillup-account-sum") === ""
        ? setAmountError(true)
        : setAmountError(false);
      formData.get("fillup-account-payment-method") === ""
        ? setMethodError(true)
        : setMethodError(false);
      if (
        formData.get("fillup-account-sum") !== "" &&
        formData.get("fillup-account-payment-method") !== ""
      ) {
        payment
          .createPayment(
            formData.get("fillup-account-payment-method"),
            formData.get("fillup-account-sum"),
            cardID,
            "https://cabinet.telekarta.tv/?payment=error",
            "https://cabinet.telekarta.tv/?payment=success",
          )
          .then((res) => {
            if (res.form.redirect) {
              sendData(res.form.action, res.form.method, res.form.fields);
            } else {
              const prepayment = document.getElementById(
                "payment-extended-slider",
              );
              prepayment.classList.add("active");
              const submitBtn = formElement.querySelector(
                'button[type="submit"]',
              );
              submitBtn.style.visibility = "hidden";
              setAction(res.form.action);
              setMethod(res.form.method);
              setOrderID(res.order_id);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  }

  function sendData(action, method, fields) {
    let form = document.createElement("form");
    form.action = action;
    form.method = method;
    for (let key in fields) {
      form.innerHTML += `<input type='hidden' name=${key} value=${fields[key]}>`;
    }
    document.body.append(form);
    form.submit();
  }

  const handlePrepaid = async (e) => {
    e.preventDefault();
    try {
      let formData = new URLSearchParams();
      formData.append("serial", serial);
      formData.append("pin_code", pinCode);
      formData.append("order_id", orderID);
      const response = await fetch(`api/${action}`, {
        method: method,
        body: formData,
      });
      const result = await response.json();
      console.log(result);
      const banner = document.getElementById("messageBanner");
      banner.style.removeProperty("display");
      if (result?.order?.status === 3) {
        setMessage(
          "Средства будут зачислены в ближайшее время после подтверждения платежа в платежной системе",
        );
        const prepayment = document.getElementById("payment-extended-slider");
        prepayment.classList.remove("active");
        const formElement = document.getElementById("paymentForm");
        const submitBtn = formElement.querySelector('button[type="submit"]');
        submitBtn.style.visibility = "visible";
      } else {
        setMessage("Платеж не был принят, проверьте данные карты предоплаты");
      }
    } catch (error) {
      console.error("Ошибка: ", error);
      setMessage("Платеж не был принят, проверьте данные карты предоплаты");
    }
  };

  return (
    <>
      <div className="main-section-switcher" id="my-account">
        <div className="main-section-switcher__container page-container">
          <h1 className="main-section-switcher__title title title--h1">
            Моя Телекарта
          </h1>
        </div>
      </div>
      <div className="fillup-account fillup-account__lka" id="fillup-account">
        <div className="fillup-account__container page-container page__area">
          <div className="fillup-account__inner">
            <h4 className="fillup-account__title title title--h4">
              Пополнить счёт карты
            </h4>
            <form className="fillup-account__form" id="paymentForm">
              <div className="fillup-account__sum">
                <input
                  className={
                    "input input--lg js-focus-outside" +
                    (amountError ? " has-error" : "")
                  }
                  name="fillup-account-sum"
                  type="text"
                  placeholder="Сумма платежа"
                />
              </div>
              <div className="fillup-account__payment-method">
                <div
                  className={
                    "select js-select select--lg" +
                    (methodError ? " has-error" : "")
                  }
                >
                  <select
                    className="select__item"
                    name="fillup-account-payment-method"
                    id="fillup-account-payment-method"
                    placeholder="Способ оплаты"
                  />
                </div>
              </div>
              <button
                className="fillup-account__submit solid-btn solid-btn--blue solid-btn--lg bttn"
                type="submit"
              >
                Продолжить
              </button>
            </form>
            <div className="fillup-account__all-payment-methods">
              <Link
                className="arrow-link arrow-link--blue"
                to="//telekarta.tv/payment/"
              >
                Все способы оплаты
                <HandySvg
                  className="svg-icon arrow-link__arrow"
                  src={iconRightArrow}
                  width="16"
                  height="16"
                />
              </Link>
              <br />
              <Link className="arrow-link arrow-link--blue" to="/autopayment">
                Автоплатеж
                <HandySvg
                  className="svg-icon arrow-link__arrow"
                  src={iconRightArrow}
                  width="16"
                  height="16"
                />
              </Link>
            </div>
          </div>
          <div
            className="recruit-account__prepaid js-recruit-extended"
            id="payment-extended-slider"
          >
            <div
              className="recruit-account__prepaid-inner"
              id="payment-extended-slider-content"
            >
              <div className="recruit-account__extended-wrap-form">
                <form
                  onSubmit={handlePrepaid}
                  id="payment_self_form"
                  className="recruit-account__extended-form"
                >
                  <div
                    className="recruit-account__extended-additory"
                    id="pay-with-prepaid-card"
                  >
                    <div className="recruit-account__extended-number">
                      <input
                        className="input input--lg js-focus-outside"
                        name="serial"
                        type="text"
                        placeholder="Серийный номер"
                        id="payment-form-input-serial-number"
                        value={serial}
                        onChange={(e) => setSerial(e.target.value)}
                      />
                      <div
                        className="recruit-account__extended-hint js-recruit-extended-hint-tooltip tooltipstered"
                        data-tooltip-content="#extended-hint-number-tooltip"
                      >
                        <HandySvg
                          className="svg-icon"
                          src={iconQuestion}
                          width="16"
                          height="16"
                        />
                      </div>
                    </div>
                    <div className="recruit-account__extended-pin">
                      <input
                        className="input input--lg js-focus-outside"
                        name="pin_code"
                        type="text"
                        placeholder="Пин-код"
                        id="payment-form-input-pin-code"
                        value={pinCode}
                        onChange={(e) => setPinCode(e.target.value)}
                      />
                      <div
                        className="recruit-account__extended-hint js-recruit-extended-hint-tooltip tooltipstered"
                        data-tooltip-content="#extended-hint-pin-tooltip"
                      >
                        <HandySvg
                          className="svg-icon"
                          src={iconQuestion}
                          width="16"
                          height="16"
                        />
                      </div>
                    </div>
                    <button
                      id="payment-card-pay-form-submit-button"
                      className="fillup-account__submit solid-btn solid-btn--blue solid-btn--lg bttn"
                      type="submit"
                    >
                      Продолжить
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FillUpAccount;
